
const API_URL='https://dhanvidiamonds.polysolinfotech.com/api/'
const DEFAULT_IMAGE ='/img/default_img.png'
const FRONT_URL =   ""  
const CATEGORIES = [];
const themesetting = {};
export default { API_URL, CATEGORIES, themesetting,DEFAULT_IMAGE,FRONT_URL };